'use client'

import clsx from 'clsx'
import { ChangeEvent, forwardRef, InputHTMLAttributes, useState } from 'react'

import cls from './switch.module.scss'

interface SwitchProps
	extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'checked' | 'onChange' | 'disabled'> {
	label?: string
	defaultChecked?: boolean
	checked?: boolean
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void
	disabled?: boolean
	className?: string
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>((props, ref) => {
	const { label, defaultChecked, checked, onChange, disabled, id, className, ...rest } = props
	const [internalChecked, setInternalChecked] = useState(defaultChecked ?? !!checked)

	const isControlled = checked !== undefined
	const value = isControlled ? checked : internalChecked

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (disabled) return

		if (!isControlled) {
			setInternalChecked(e.target.checked)
		}

		onChange?.(e)
	}

	const rootClasses = clsx(cls.root, value && cls.root__active, disabled && cls.root__disabled)

	return (
		<div className={clsx(cls.wrap, className)}>
			<div className={rootClasses}>
				<input
					aria-checked={value}
					ref={ref}
					type="checkbox"
					className={cls.input}
					checked={value}
					onChange={handleChange}
					disabled={disabled}
					id={id}
					{...rest}
				/>
				<div className={cls.marker} />
			</div>
			{label && <p className={cls.label}>{label}</p>}
		</div>
	)
})
